import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";

export interface ICancelSubscriptionResponse {
  message: string;
  cancel_at_period_end: boolean;
  current_period_end: string;
}

export const useCancelSubscription = () => {
  const queryClient = useQueryClient();

  return useMutation<ICancelSubscriptionResponse, Error, { immediate: boolean }>({
    mutationFn: async (payload: { immediate: boolean }) => {
      return await httpService.post<ICancelSubscriptionResponse>(
        API_CONFIG.path.stripeCancel,
        payload as unknown as Record<string, unknown>
      );
    },
    onSuccess: () => {
      // Invalidate subscription details to refresh the UI
      queryClient.invalidateQueries({ queryKey: ["stripe", "details"] });
      queryClient.invalidateQueries({ queryKey: ["stripe", "history"] });
    },
  });
};
